import React from 'react';
import { IntlContext, type IntlShape } from 'react-intl';

/**
 * Ersatz fuer das in react-intl 10 entfallene `injectIntl`.
 *
 * Die Bibliothek bietet nur noch den Hook `useIntl`. Da rund 56 Ansichten in
 * diesem Projekt Klassenkomponenten sind, kommt ein Hook dort nicht in Frage;
 * dieses HOC reicht `intl` weiterhin als Prop hinein und haelt den bisherigen
 * Aufrufcode unveraendert.
 *
 * Sobald die betroffenen Komponenten auf Funktionskomponenten umgestellt sind,
 * kann diese Datei entfallen und durch `useIntl()` ersetzt werden.
 */
export interface WrappedComponentProps {
  intl: IntlShape;
}

export function injectIntl<P extends WrappedComponentProps>(
  Component: React.ComponentType<P>,
): React.FC<Omit<P, 'intl'>> {
  const Wrapped: React.FC<Omit<P, 'intl'>> = (props) => (
    <IntlContext.Consumer>
      {(intl) => <Component {...(props as P)} intl={intl as IntlShape} />}
    </IntlContext.Consumer>
  );

  Wrapped.displayName = `injectIntl(${Component.displayName ?? Component.name ?? 'Component'})`;
  return Wrapped;
}

export default injectIntl;
